function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import color from "color";
import { memo, useEffect, useRef, useState } from "react";
import { Animated, Easing, View } from "react-native";
import { Actor, ChatSide } from "@oui/lib/src/types";
import { useConversationContext } from "./ConversationContext";
import { ChatTypingIndicator } from "./ChatTypingIndicator";
import { Markdown } from "./Markdown";
import { Text } from "./Text";
import { useTheme } from "../styles";
var BORDER_RADIUS = 16;
var OUTER_MIN_HEIGHT = 68;
var MARKDOWN_REGEX = /[\*\_\-\|]|(\d. )/;
function ChatBubble(_param) {
    var backgroundColor = _param.backgroundColor, borderColor = _param.borderColor, isAlignStart = _param.isAlignStart, sameSideAsPrevious = _param.sameSideAsPrevious, extraMargin = _param.extraMargin, style = _param.style, text = _param.text, rest = _object_without_properties(_param, [
        "backgroundColor",
        "borderColor",
        "isAlignStart",
        "sameSideAsPrevious",
        "extraMargin",
        "style",
        "text"
    ]);
    var theme = useTheme().theme;
    var textColor = color(backgroundColor).darken(0.15).isDark() ? 'white' : theme.color.gray100;
    var isMarkdown = typeof text === 'string' && MARKDOWN_REGEX.exec(text);
    return /*#__PURE__*/ _jsx(View, _object_spread_props(_object_spread({}, rest), {
        style: [
            {
                alignSelf: isAlignStart ? 'flex-start' : 'flex-end',
                marginBottom: 5,
                marginHorizontal: 12,
                marginTop: extraMargin ? 15 : 5
            },
            _object_spread({
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderRadius: BORDER_RADIUS,
                borderWidth: 2,
                flexGrow: 0,
                flexShrink: 1,
                justifyContent: 'center',
                overflow: 'hidden',
                maxWidth: '80%',
                padding: 16,
                flexDirection: 'row'
            }, sameSideAsPrevious ? {} : isAlignStart ? {
                alignItems: 'flex-start',
                borderTopLeftRadius: 0
            } : {
                alignItems: 'flex-end',
                borderTopRightRadius: 0
            }),
            style
        ],
        children: isMarkdown ? /*#__PURE__*/ _jsx(Markdown, {
            fontFamily: "OpenSansSemiBold",
            textColor: textColor,
            style: {
                body: {
                    flexGrow: 1
                },
                ordered_list_content: {
                    flex: undefined,
                    flexGrow: 1,
                    maxWidth: '90%'
                }
            },
            children: text
        }) : typeof text === 'string' ? /*#__PURE__*/ _jsx(Text, {
            text: text,
            weight: "semibold",
            color: textColor
        }) : text
    }));
}
/**
 * Renders a chat message in a bubble UI. The message may be plain text,
 * markdown text, or a ReactNode that handles it's own rendering.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-72}
 */ export var ChatText = /*#__PURE__*/ memo(function(param) {
    var _param_accessible = param.accessible, accessible = _param_accessible === void 0 ? true : _param_accessible, _backgroundColor = param.backgroundColor, bubbleStyle = param.bubbleStyle, sameSideAsPrevious = param.sameSideAsPrevious, extraMargin = param.extraMargin, _param_side = param.side, side = _param_side === void 0 ? ChatSide.START : _param_side, value = param.value;
    var _useConversationContext = useConversationContext(), receivedMessageBorderColor = _useConversationContext.receivedMessageBorderColor, sentMessageBackgroundColor = _useConversationContext.sentMessageBackgroundColor;
    var isAlignStart = side === ChatSide.START;
    var backgroundColor = (_backgroundColor !== null && _backgroundColor !== void 0 ? _backgroundColor : isAlignStart) ? 'white' : sentMessageBackgroundColor;
    var borderColor = isAlignStart ? receivedMessageBorderColor : sentMessageBackgroundColor;
    return /*#__PURE__*/ _jsx(ChatBubble, {
        accessible: accessible,
        "aria-label": accessible ? (sameSideAsPrevious ? '' : isAlignStart ? 'Aviva said: ' : 'You said: ') + (typeof value === 'string' ? value.replace(/\*/g, '') : 'Unknown') : undefined,
        backgroundColor: backgroundColor,
        borderColor: borderColor,
        extraMargin: extraMargin,
        isAlignStart: isAlignStart,
        sameSideAsPrevious: sameSideAsPrevious,
        style: bubbleStyle,
        text: value
    });
});
function InnerAnimating(param) {
    var children = param.children;
    var _useState = _sliced_to_array(useState(true), 2), preTransition = _useState[0], setPreTransition = _useState[1];
    var animationRef = useRef(new Animated.Value(1));
    useEffect(function() {
        setPreTransition(false);
        Animated.timing(animationRef.current, {
            toValue: 0,
            useNativeDriver: true,
            easing: Easing.linear,
            duration: 300
        }).start();
    }, []);
    return /*#__PURE__*/ _jsx(Animated.View, {
        style: {
            transform: [
                {
                    translateY: animationRef.current.interpolate({
                        inputRange: [
                            0,
                            1
                        ],
                        outputRange: [
                            0,
                            100
                        ]
                    })
                }
            ]
        },
        children: preTransition ? null : children
    });
}
/**
 * Manages the display of chat messages with an animated typing indicator. It
 * accepts an actor type (User or Bot), chat content, and a flag indicating if
 * the current message shares the same side as the previous one. The component
 * controls the visibility of a typing indicator when the Bot actor is present
 * and introduces a delay before revealing the actual chat content. It utilizes
 * React's state and animation capabilities to create a smooth transition
 * between the indicator and the displayed text.
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-66}
 */ export function AnimatingChatText(param) {
    var actor = param.actor, children = param.children, sameSideAsPrevious = param.sameSideAsPrevious;
    var _useState = _sliced_to_array(useState(actor === Actor.Bot), 2), showIndicator = _useState[0], setShowIndicator = _useState[1];
    var _useState1 = _sliced_to_array(useState(!showIndicator), 2), showContent = _useState1[0], setShowContent = _useState1[1];
    var indicatorOpacity = useRef(new Animated.Value(1));
    useEffect(function() {
        var timeout = 0;
        if (!showContent) {
            timeout = setTimeout(function() {
                setShowContent(true);
                Animated.timing(indicatorOpacity.current, {
                    useNativeDriver: true,
                    toValue: 0,
                    duration: 400
                }).start(function() {
                    setShowIndicator(false);
                });
            }, 1000);
            return function() {
                return clearTimeout(timeout);
            };
        }
        return;
    }, [
        showContent
    ]);
    return /*#__PURE__*/ _jsxs(View, {
        // OUTER_MIN_HEIGHT was calculated measureing the height of 1 line of text
        // onLayout={({ nativeEvent }) => console.log(nativeEvent.layout)}
        style: {
            minHeight: OUTER_MIN_HEIGHT,
            overflow: 'hidden'
        },
        children: [
            showIndicator ? /*#__PURE__*/ _jsx(Animated.View, {
                style: {
                    position: showContent ? 'absolute' : 'relative',
                    bottom: 0,
                    width: '100%',
                    opacity: indicatorOpacity.current,
                    height: OUTER_MIN_HEIGHT,
                    zIndex: 0
                },
                children: /*#__PURE__*/ _jsx(ChatText, {
                    value: /*#__PURE__*/ _jsx(ChatTypingIndicator, {}),
                    side: actor === Actor.User ? ChatSide.END : ChatSide.START,
                    sameSideAsPrevious: sameSideAsPrevious
                })
            }) : null,
            showContent ? /*#__PURE__*/ _jsx(InnerAnimating, {
                children: children
            }) : null
        ]
    });
}
